import { CustomCell } from '../../components/custom-cell';
import { getNumericOperators } from '../../utils/getNumericOperators';
import { ToggleCell } from './components/toggle-cell';
import { getStringOperators } from '../../utils/getStringOperators';

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const TABLE_COLUMNS = () => {
	return [
		{
			headerName: '#',
			field: 'id',
			width: 100,
			minWidth: 100,
			align: 'center',
			headerAlign: 'center',
			type: 'number',
			cellClassName: 'id',
			filterOperators: getNumericOperators(),
			renderCell: params => CustomCell(params),
		},
		{
			headerName: 'ФИО',
			field: 'name',
			flex: 2,
			filterOperators: getStringOperators(),
			renderCell: params => CustomCell(params),
		},
		{ headerName: 'Почта', field: 'email', flex: 2, sortable: false, filterOperators: getStringOperators() },
		{ headerName: 'Телефон', field: 'phone', flex: 1, sortable: false, filterOperators: getStringOperators() },
		{
			headerName: 'По умолчанию',
			field: 'is_default',
			width: 150,
			sortable: false,
			filterable: false,
			// eslint-disable-next-line react/react-in-jsx-scope
			renderCell: params => <ToggleCell rowData={params.row} columnId={params.field} />,
		},
	];
};
